/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';
import { IntlMessages } from '../../../helper/langHelper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 600px;
  margin: 0 auto;
`;

const Title = styled.h4`
  font-size: 16px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 8px;
  line-height: 1.5;
`;

const Subtitle = styled.p`
  font-size: 14px;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const DisclaimerText = styled.ul`
  font-size: 14px;
  margin-left: 45px;
  list-style-type: disc;
  margin-bottom: 24px;
  line-height: 1.5;

  li {
    margin-bottom: 8px;

    a {
      color: #2563eb;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 24px;
`;

const Checkbox = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  margin-top: 2px;

  &:checked {
    background-color: #2563eb;
    border-color: #2563eb;
    position: relative;

    &:after {
      content: '✓';
      color: #fff;
      font-size: 12px;
      position: absolute;
      top: 1px;
      left: 4px;
    }
  }
`;

const LabelText = styled.label`
  font-size: 14px;
  color: #111827;
  line-height: 1.5;
`;

const Button = styled.button`
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: ${(p) => (p.disabled ? '#9ca3af' : '#fff')};
  border: none;
  border-radius: ${key('sizes.borderRadius.small', '10px')};
  padding: 12px 24px;
  font-size: 14px;
  font-weight: bold;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease;
  &:hover {
    cursor: pointer;
    /* background: linear-gradient(90deg, #60a5fa, #7b5cff);
    transition: all 0.3s ease; */
  }
  ${({ disabled }) =>
    disabled
      ? css`
          color: gray;
          cursor: not-allowed !important;
          background: ${palette('gray', 0)} !important;
          border: none !important;
        `
      : css``}
`;

const TermsAndConditions = ({ handleGenerateReport }) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Container>
      <Title>
        <IntlMessages id="disclaimer.title" />
      </Title>
      <Subtitle>
        <IntlMessages id="disclaimer.subtitle" />
      </Subtitle>

      <DisclaimerText>
        <li>
          <IntlMessages id="disclaimer.point1" />
        </li>

        <li>
          <a href="#">Urban Compass</a> <IntlMessages id="disclaimer.point2" />
        </li>
      </DisclaimerText>

      <CheckboxContainer>
        <Checkbox type="checkbox" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
        <LabelText>
          <IntlMessages id="disclaimer.checkbox.label" />
        </LabelText>
      </CheckboxContainer>

      <Button disabled={!isChecked} onClick={handleGenerateReport}>
        <IntlMessages id="button.generate.report" />
      </Button>
    </Container>
  );
};

export default TermsAndConditions;
